import { useEffect, useState } from "react";
import CustomButton from "../CustomButton";
import MenuList from "../MenuList";

interface PaginationBarProps {
	labelShowing?: string;
	labelResults?: string;
	isPageable?: boolean;
	nextLabel?: string;
	previousLabel?: string;
	nextEnabled: boolean;
	previousEnabled: boolean;
	onNextPage: () => void;
	onPreviousPage: () => void;
	onChangePageSize?: (pageSize: number) => void;
	pageSizeOptions?: number[];
	isRelational?: boolean;
	labelTo?: string;
	totalCount?: number;
	labelRows?: string;
	page: number;
	labelOf?: string;
}

export default function PaginationBar(props: PaginationBarProps) {
	const {
		labelShowing,
		labelResults,
		previousLabel,
		nextLabel,
		nextEnabled,
		previousEnabled,
		onNextPage,
		onPreviousPage,
		pageSizeOptions,
		onChangePageSize,
		labelTo,
		totalCount,
		labelRows,
		page,
		labelOf,
	} = props;

	const [pageSize, setPageSize] = useState((pageSizeOptions || [5])[0]);

	useEffect(() => {
		if (onChangePageSize) {
			onChangePageSize(pageSize);
		}
	}, [pageSize]);

	return (
		<nav
			className="flex flex-col sm:flex-row items-center justify-between border-t px-2 py-2 sm:px-4 sm:py-3"
			aria-label="Pagination"
		>
			<div className="flex flex-col md:flex-row items-center justify-between gap-4 w-full lg:min-w-52">
				<p className="text-sm text-center sm:text-left min-w-52">
					{labelShowing || "Showing"}{" "}
					<span className="font-medium">{1 + page * pageSize} </span>
					{labelTo || "to"}{" "}
					<span className="font-medium">{(page + 1) * pageSize} </span>
					{labelOf || "of"} <span className="font-medium">{totalCount}</span>{" "}
					{labelResults || "results"}
				</p>
				<div className="w-full h-9 hidden md:flex">
					<MenuList
						buttonLabel={`${pageSize} ${labelRows || "rows"}`}
						menuOptions={pageSizeOptions}
						onChange={(_pageSize) => setPageSize(_pageSize)}
					/>
				</div>
			</div>
			<div className="flex flex-col justify-end sm:flex-row w-full sm:w-auto sm:justify-between gap-2 mt-4 sm:mt-0">
				<CustomButton
					disabled={!previousEnabled}
					onClick={onPreviousPage}
					className="w-full sm:w-auto"
				>
					{previousLabel || "Previous"}
				</CustomButton>
				<CustomButton
					disabled={!nextEnabled}
					onClick={onNextPage}
					className="w-full sm:w-auto"
				>
					{nextLabel || "Next"}
				</CustomButton>
			</div>
			<div className="w-full h-9 sm:flex md:hidden mt-4">
				<MenuList
					buttonLabel={`${pageSize} ${labelRows || "rows"}`}
					menuOptions={pageSizeOptions}
					onChange={(_pageSize) => setPageSize(_pageSize)}
				/>
			</div>
		</nav>
	);
}
